export const focusIcon = (
  <svg width='4' height='16' viewBox='0 0 4 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.57627 0.634766L3.29928 10.8194H0.69985L0.415759 0.634766L3.57627 0.634766ZM1.99957 15.3649C1.53082 15.3649 1.12835 15.1992 0.79218 14.8677C0.456005 14.5315 0.290286 14.1291 0.295021 13.6603C0.290286 13.1963 0.456005 12.7986 0.79218 12.4672C1.12835 12.1357 1.53082 11.97 1.99957 11.97C2.44938 11.97 2.84474 12.1357 3.18565 12.4672C3.52655 12.7986 3.69938 13.1963 3.70411 13.6603C3.69938 13.9728 3.61652 14.2593 3.45553 14.5197C3.29928 14.7754 3.09332 14.9814 2.83763 15.1376C2.58195 15.2891 2.3026 15.3649 1.99957 15.3649Z'
      fill='#00629B'
    />
  </svg>
);
